import { localesMap } from '@helpers/localesMap.js';
import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { errorLogger } from '@utils/errorLogger.util.js';
import { api } from '@utils/ky.util.js';

export const useUserStore = create((set) => ({
  loading: true,
  user: null,
  error: null,
  isEventAvailable: false,

  setUser: (user) => {
    set({ user: user, loading: false, error: null });
  },
  setEventAvailable: (isEventAvailable) => {
    set({ isEventAvailable: isEventAvailable });
  },

  fetchUser: async (chat_id) => {
    try {
      const response = await api
        .get('get-user-data', {
          searchParams: { chat_id: chat_id },
        })
        .json();

      if (!response.success) {
        set({ error: response.message });
        return;
      }

      const user = {
        ...response,
        formattedLang: localesMap[response.lang] ?? response.lang,
        isPromoter: response.initiator_id !== response.contact_id,
        isAdmin: response.admin === 'true',
      };

      set({
        error: null,
        user: user,
        isEventAvailable: response.isEventAvailable ?? false,
      });
    } catch (error) {
      errorLogger.error(error, { source: 'useUserStore' });
      set({ error: 'Error during load user data. Try to reload app.' });
    } finally {
      set({ loading: false });
    }
  },
}));

export const useUser = () => {
  return useUserStore(
    useShallow((state) => ({
      user: state.user,
      isUserLoading: state.loading,
      userError: state.error,
      isEventAvailable: state.isEventAvailable,
      fetchUser: state.fetchUser,
    })),
  );
};
